import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import VipFeatures from "./components/VipFeatures";
import HotComics from "./components/HotComics";
import Categories from "./components/Categories";
import Experience from "./components/Experience";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { hotComics } from "@/mocks/comics";
import { faqs } from "@/mocks/faqs";

const siteUrl = "https://koreamx0.github.io/";

function SeoJsonLd() {
  const ld = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "韩漫土豪漫画网",
      url: siteUrl,
      description:
        "专注原版韩漫的尊享阅读平台，VIP章节付费解锁抢先看，高画质无广告阅读，分类齐全，每日更新。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${siteUrl}?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "韩漫土豪漫画网",
      url: siteUrl,
      logo: `${siteUrl}logo.png`,
      sameAs: [],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "韩漫土豪漫画网 | VIP章节付费解锁·无广告高画质原版韩漫阅读",
      url: siteUrl,
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", url: siteUrl, name: "韩漫土豪漫画网" },
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "热门韩漫推荐",
      itemListElement: hotComics.slice(0, 8).map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.title,
        image: c.cover,
        url: `${siteUrl}#hot`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <>
      {ld.map((item, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}

export default function Home() {
  return (
    <>
      <SeoJsonLd />
      <div className="min-h-screen bg-background-950 text-foreground-100">
        <Navbar />
        <main>
          <Hero />
          <VipFeatures />
          <HotComics />
          <Categories />
          <Experience />
          <Pricing />
          <Testimonials />
          <About />
          <Faq />
          <Subscribe />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}